import { Button, Col, Form, Input, Modal, Row } from 'antd'
import React, { useState, useEffect, useRef } from 'react'
import EditableTable from './EditableTable'
import { Label } from '@material-ui/icons';
import { useLocation } from 'react-router-dom';
import { DownloadDatasheet, DownloadMaintenanceHistory } from '../../../Services/employee';
import { getDatasheetData } from '../../../Services/LocomotiveServices';
import moment, { utc } from 'moment';

const DataSheetModal = ({ open, setOpen, onOk, onCancel }) => {

    const [form] = Form.useForm();
    const [TableData, setTableData] = useState({})
    const [editingKey, setEditingKey] = useState('');
    const params = useRef(true)

    const { state } = useLocation()

    const idDatasheet = state?.data?.id;
    const Equipuid = state?.data?.equipUid;

    const DownloadDatasheetupdated = async () => {
         

        try {
            const response = await DownloadDatasheet({ idDatasheet });
            const blob = new Blob([response], { type: 'application/pdf' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `Datasheet.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error('Error exporting data:', error);
        }
    }
    const fetchInitialData = async (condition) => {
        try {
            if (condition == 'Table') {
                params.current = false;
            }
            else {
                params.current = true;

            }
            const apiData = await getDatasheetData(idDatasheet, params.current);
            if (apiData?.httpStatus === 200) {
                // setParams(!params)
                const newData = apiData?.data || {};
                setTableData(newData);
                 
                form.setFieldsValue({
                    equipId: newData?.EquipUID || 'N/A',
                    model: newData?.Loco_Model || 'N/A',
                    yrBuilt: newData?.Mfr_Year 
                    ? moment(newData.Mfr_Year).format('YYYY') 
                    : 'N/A',                    hp: newData?.Loco_HP || 'N/A',

                });
            }
        } catch (error) {
            console.error('Error fetching initial data:', error);
        }
    };
    //  

    useEffect(() => {
        fetchInitialData();
    }, [open]);

    const cancel = () => onCancel(setEditingKey)

    return (
        <div  >
            <Modal
                title={(
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <span style={{ color: '#2963ad', fontSize: '20px', fontWeight: '800' }}>Equipment Data sheet</span>
                        <Button style={{
                            marginRight: '20px',
                            background: '#2863ad',
                            color: "white",
                            borderRadius: "10px",
                        }}
                            // onClick={DownloadDatasheet}
                            onClick={() => { DownloadDatasheetupdated() }}
                        >
                            Download
                        </Button>
                    </div>
                )} open={open} onOk={onOk} onCancel={cancel}
                footer={null}
                className='ModalWidth'
            >
                <Form form={form} style={{ marginTop: '-17px', marginBottom: '5px' }}>
                    <Row>

                        <Form.Item name="equipId" label="Equip ID" style={{ fontWeight: 'bold', marginBottom: '-6px' }} >
                            <Input style={{ background: 'none', border: 'none', color: 'black' }} disabled />
                        </Form.Item>
                    </Row>
                    <Row>
                        <Form.Item name="model" label="Model" style={{ fontWeight: 'bold', marginBottom: '-6px' }}>
                            <Input style={{ background: 'none', border: 'none', color: 'black', marginLeft: '13px' }} disabled />

                        </Form.Item>
                    </Row>
                    <Row>
                        <Form.Item name="hp" label="HP" style={{ fontWeight: 'bold', marginBottom: '-6px' }} >
                            <Input style={{ background: 'none', border: 'none', color: 'black', marginLeft: '38px' }} disabled />

                        </Form.Item>
                    </Row>
                    <Row>
                        <Form.Item name="yrBuilt" label="Yr Built" style={{ fontWeight: 'bold', marginBottom: '-3px' }}>
                            <Input style={{ background: 'none', border: 'none', color: 'black', paddingLeft: '17px' }} disabled />

                        </Form.Item>
                    </Row>

                </Form>


                <div style={{ zoom: '0.6', height: 'auto', fontSize: '18px' }}>
                    <EditableTable reload={fetchInitialData} tableData={TableData}
                        params={params}
                        handleDataSheetTable={() => { fetchInitialData('Table') }}
                        modalOpen={open}
                        editingKey={editingKey}
                        setEditingKey={setEditingKey}
                        
                    />
                </div>
            </Modal>

        </div>
    )
}

export default DataSheetModal